'use client'

import { useState } from 'react'

import { HStack } from '@podo-app/design-system-temp'

import { STAR_COLORS } from './nps-survey.constants'
import type { NpsRating } from './nps-survey.types'

const STAR_SIZE = 44

interface StarIconProps {
  filled: boolean
  onClick: () => void
}

const StarIcon = ({ filled, onClick }: StarIconProps) => (
  <button type="button" onClick={onClick} className="p-0 bg-transparent border-none cursor-pointer">
    <svg width={STAR_SIZE} height={STAR_SIZE} viewBox="0 0 44 44" fill="none">
      <path
        d="M21.3461 2.01235C21.552 1.37894 22.448 1.37895 22.6539 2.01235L26.785 14.7266C26.877 15.0098 27.141 15.2016 27.4388 15.2016H40.8073C41.4733 15.2016 41.7502 16.0539 41.2114 16.4453L30.3961 24.3032C30.1551 24.4782 30.0543 24.7885 30.1463 25.0718L34.2774 37.786C34.4832 38.4194 33.7583 38.9461 33.2195 38.5547L22.4041 30.6968C22.1631 30.5218 21.8369 30.5218 21.5959 30.6968L10.7805 38.5547C10.2417 38.9461 9.51677 38.4194 9.72258 37.786L13.8537 25.0718C13.9457 24.7885 13.8449 24.4782 13.6039 24.3032L2.78856 16.4453C2.24976 16.0539 2.52667 15.2016 3.19266 15.2016H16.5612C16.859 15.2016 17.123 15.0098 17.215 14.7266L21.3461 2.01235Z"
        fill={filled ? STAR_COLORS.on : STAR_COLORS.off}
        stroke={filled ? STAR_COLORS.stroke : 'none'}
      />
    </svg>
  </button>
)

interface StarRatingProps {
  value: NpsRating | null
  onChange: (rating: NpsRating) => void
}

export const StarRating = ({ value, onChange }: StarRatingProps) => {
  const [hovered, setHovered] = useState<number | null>(null)
  const activeValue = hovered ?? value ?? 0

  return (
    <HStack className="gap-2" onMouseLeave={() => setHovered(null)} data-testid="star-rating">
      {([1, 2, 3, 4, 5] as const).map((star) => (
        <div key={star} onMouseEnter={() => setHovered(star)}>
          <StarIcon filled={star <= activeValue} onClick={() => onChange(star)} />
        </div>
      ))}
    </HStack>
  )
}
